// extracted by mini-css-extract-plugin
module.exports = {"link":"PopupMenuItem_link__e_ZIi","icon":"PopupMenuItem_icon__5JUvZ"};